import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

import { DevModeImg } from '@app/assets';
import { CALENDAR_PATH, PREFIX } from '@app/constants';
import '@app/components/DevMode/styles/DevMode.desktop.scss';

const devModeTitle =
  'Данная часть системы находится в процессе разработки. ' +
  'Пожалуйста, посетите ее позднее.';

export const DevMode = () => {
  return (
    <div className={`${PREFIX}dev-mode`}>
      <div className="alert-box">
        <Result
          title={devModeTitle}
          icon={<img alt="Изображение статуса разработки" src={DevModeImg} />}
          extra={
            <Link to={CALENDAR_PATH}>
              <Button type="primary" key="console">
                На главную
              </Button>
            </Link>
          }
        />
      </div>
    </div>
  );
};
